import { render, staticRenderFns } from "./AddPayrollSchedule.vue?vue&type=template&id=04d2495f&scoped=true&"
import script from "./AddPayrollSchedule.vue?vue&type=script&lang=js&"
export * from "./AddPayrollSchedule.vue?vue&type=script&lang=js&"
import style0 from "./AddPayrollSchedule.vue?vue&type=style&index=0&id=04d2495f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d2495f",
  null
  
)

export default component.exports